module.exports = __webpack_public_path__ + "mastercard.e18994fdf301400fa870.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/mastercard.svg
// module id = ../../../../../src/img/mastercard.svg
// module chunks = styles